import React from 'react'

import LazyLoad from 'react-lazyload'

import pin from '../images/pin.svg'

export default function InfoGridItem({ number, p, src }) {
  return (
    <div className='infogr__item'>
      <div className='infogr__figure'>
        <LazyLoad height='200'>
          <img className='infogr__image' src={src} alt='' />
          <div className='infogr__pin'>
            <div style={{ position: 'relative' }}>
              <div className='infogr__number'>{number}</div>
              <img src={pin} alt='' />
            </div>
          </div>
        </LazyLoad>
      </div>
      <p className='infogr__paragraph'>{p}</p>
    </div>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/InfogrItem.jsx